import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  listItem: {
    marginBottom: 0,
  },
  listItemInner: {
    display: 'block',
    padding: '16px 14px',
    margin: 0,
    color: 'var(--ui-color-text)',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--ui-color-light)',
    },
  },
}))

export default useStyles
